import React, { useState } from "react"
import { connect } from "react-redux"

import { actions } from "client/documents/actions"
import { DocumentType } from "client/documents/types"
import { hasDocuments, ModalDocument } from "client/documents/utils"
import { Button } from "components/Button"
import { Card } from "components/Card/Card"
import { Buttons } from "components/Card/Card"
import { Modal } from "components/Modal/Modal"
import PreviousButton from "components/Previous/PreviousButton"
import { Information } from "components/Title/Title"
import { logout } from "containers/Login/services/actions"
import { cdn } from "core/cdn"
import { languages } from "lib/languages"
import { MedicalPath } from "types/entity"
import { Call } from "types/payload"
import { Dispatcher, Message } from "types/redux"
import { ClientStore, DocumentsStore } from "types/store"

import styles from "./Finale.module.scss"

interface FinaleProps {
  logout: () => void
  getDocuments: (callId: string, documentsType?: DocumentType[]) => void
  medicalPath: MedicalPath
  documentUrl?: string
  call?: Call
  message?: Message
}

const Finale: React.FC<FinaleProps> = (props): JSX.Element => {
  const [chosenCall, setChosenCall] = useState<Call>()
  const [disconnectModalVisible, setDisconnectModalVisible] =
    useState<boolean>(false)

  const logout = () => {
    props.logout()
  }
  return (
    <>
      <PreviousButton text={languages.logout} reset={true} />
      {props.call && hasDocuments(props.call) ? (
        <Card
          title={languages.finalePageTitle}
          message={props.message}
          imgUrl={cdn("/images/tlc_terminee_illustration.svg")}
        >
          <div className={styles.Infos}>
            <img src={cdn("/icons/information.svg")} width="30px" alt="information" />
            <div>
              <div>{languages.problemWithYourDocument}</div>
              <div>{languages.askToScanQrCode}</div>
            </div>
          </div>
          <Buttons style={{ gap: "30px" }}>
            <div className={styles.LegalMention}>
              <img
                src={cdn("/images/information_icon.svg")}
                alt="information_icon"
              />
              <span className={styles.ArticleSix}>
                {languages.legalMentionArticleSix}
              </span>
            </div>
            <Button onClick={() => setChosenCall(props.call)} type="primary">
              {languages.printDocument}
            </Button>
          </Buttons>
        </Card>
      ) : (
        <Card title={languages.noDocument}>
          <Buttons>
            <Button disabled={true} type="primary">
              {languages.printDocument}
            </Button>
            <Button onClick={logout} type="link">
              {languages.logout}
            </Button>
          </Buttons>
        </Card>
      )}
      <ModalDocument
        call={chosenCall}
        onCancel={logout}
        onAccept={() => {
          setChosenCall(undefined)
          setDisconnectModalVisible(true)
        }}
        acceptButtonProps={{ danger: true }}
        acceptText={languages.logout}
      />
      <Modal
        visible={disconnectModalVisible}
        title={languages.beSureToBeDisconnected}
        onCancel={() => {
          setDisconnectModalVisible(false)
          setChosenCall(props.call)
        }}
        cancelButtonProps={{ type: "primary" }}
        cancelText={languages.rePrint}
        acceptButtonProps={{ danger: true, type: "primary" }}
        acceptText={languages.finishAndDisconnect}
        onAccept={() => {
          logout()
        }}
      >
        <Information text={languages.beSureDocumentsArePrinted} />
      </Modal>
    </>
  )
}

const mapStateToProps = ({
  client,
  documents,
}: {
  client: Partial<ClientStore>
  documents: Partial<DocumentsStore>
}): Partial<FinaleProps> => {
  return {
    documentUrl: client.documentUrl,
    call: client.call,
    medicalPath: client.medicalPath,
    message: documents.message,
  }
}
const mapDispatchToProps = (dispatch: Dispatcher): Partial<FinaleProps> => {
  return {
    logout: () => dispatch(logout()),
    getDocuments: (callId: string, documentsType?: DocumentType[]) =>
      dispatch(actions.request(callId, documentsType)),
  }
}

const FinalePage = Finale
export default connect(mapStateToProps, mapDispatchToProps)(FinalePage)
